export const labelScore = (starsAmount: number) => {
	if (starsAmount === 1) {
		return '1 - 49 %'
	}
	if (starsAmount === 2) {
		return '50 - 59 %'
	}
	if (starsAmount === 3) {
		return '60 - 69 %'
	}
	if (starsAmount === 4) {
		return '70 - 79 %'
	}
	if (starsAmount === 5) {
		return '80 - 100 %'
	}
	return '0 %'
}
